import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { TitreDescriptionVideo } from '@components/titre-description-video/models';
import { TitleComponent } from '@shared/components/title';
import { VideoComponent } from '@shared/components/video';
import { YoutubePlayerComponent } from '@shared/components/youtube-player';
import { YoutubeIdExtractorPipe } from '@shared/components/youtube-player/pipes';
import { HandleHtmlLinksDirective } from '@shared/directives';
import { IsVideoPipe, IsVideoYoutubePipe } from '@shared/pipe';

@Component({
  selector: 'app-titre-description-video',
  templateUrl: './titre-description-video.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TitleComponent,
    HandleHtmlLinksDirective,
    VideoComponent,
    IsVideoPipe,
    IsVideoYoutubePipe,
    YoutubeIdExtractorPipe,
    YoutubePlayerComponent,
  ],
})
export class TitreDescriptionVideoComponent extends AbstractDynamicComponent<TitreDescriptionVideo> {}
